//Boilerplate
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { clone } from "lodash";
import { dateToStringYy } from "components/Shared/Formatters";

//Our Stuff
import MacCard from "components/User/Mac/MacCard";
import { getPaySummary } from "actions/homeowner/fieldReps";

class FieldRepMacCard extends React.Component {

    constructor(props) {
        super(props);
        this.getPaySummary = this.getPaySummary.bind(this);
        this.getRows = this.getRows.bind(this);
    }

    getRows(paySummary) {
        const {payPeriodCases, totalMac, totalCaseCost, totalMileage, totalHours} = paySummary;
        let rows = clone(payPeriodCases);
        rows.map(row => row.submittedDate = dateToStringYy(row.submittedDate));
        if(rows.length > 0) {
            rows.push({
                submittedDate: "Total",
                mileage: totalMileage,
                minutes: totalHours,
                mac: `$${totalMac}`,
                caseCost: `$${totalCaseCost}`,
            });
        }
        return rows;
    }

    getPaySummary(inspectorNumber, payPeriodId) {
        const {getPaySummary} = this.props;
        getPaySummary(inspectorNumber, payPeriodId);
    }

    render() {
    const {inspectorNumber, isFetchingInspectorPayPeriodSummary, inspectorPayPeriodSummary} = this.props;
    return (
        <div className="fr-mac">
            <MacCard
                employeeID={inspectorNumber}
                getPaySummary={this.getPaySummary}
                isFetchingPayPeriodSummary={isFetchingInspectorPayPeriodSummary}
                paySummary={inspectorPayPeriodSummary}
                getRows={this.getRows}
                FRMac
            />
        </div>
        );
    }
}

FieldRepMacCard.propTypes = {
    //Pure Props
    inspectorNumber: PropTypes.number,

    //Redux Store State
    inspectorPayPeriodSummary: PropTypes.object,
    isFetchingInspectorPayPeriodSummary: PropTypes.bool,

    //Redux Actions
    getPaySummary: PropTypes.func,
};

const mapStateToProps = state => ({
    //Pay Period Sumary
    inspectorPayPeriodSummary: state.assignment.inspectorPayPeriodSummary,
    isFetchingInspectorPayPeriodSummary: state.assignment.isFetchingInspectorPayPeriodSummary
  });
  
  const mapDispatchToProps = dispatch => ({
    getPaySummary(inspectorNumber, payPeriodId) {
      dispatch(getPaySummary(inspectorNumber, payPeriodId));
    }
  });

export default connect(mapStateToProps, mapDispatchToProps)(FieldRepMacCard);